import BaseModel from './base-modeles/base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import Fill from '@src/slide/domain/ui-model/element-modeles/property/fill';
import { IFillProperty } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

export const proxyHandler = {
    get(target, prop) {
        if (prop === 'props' || prop === 'changeSetEngine') {
            const curSlide = getSelectionService()?.currentSlide;
            if (curSlide) {
                return curSlide[prop];
            }
            return target[prop];
        }
        return target[prop];
    },
};


function getSelectionService(): ISelectionService | undefined {
    const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
    if (appService?.viewableServiceLayer?.selectionService) {
        return appService.viewableServiceLayer.selectionService;
    }
    return undefined;
}

// 未选中时的model
class EmptyModel extends BaseModel implements IEmptyModel {
    private fillInstance: IFillProperty;  // 填充实例
    private currentSlide: ISlideModel;
    constructor(props) {
        super(props);
        this.type = UIModelType.EMPTY;
    }

    public getBackgroundFill(): IFillProperty {
        const currentSlide = getSelectionService()?.currentSlide;
        if (!currentSlide) {
            this.fillInstance = new Fill(this);
        } else  if (this.currentSlide !== currentSlide) {
            this.currentSlide = currentSlide;
            this.fillInstance = new Fill(this.currentSlide);
        }
        if (!this.fillInstance) {
            this.fillInstance = new Fill(this.currentSlide);
        }
        return this.fillInstance;
    }
}

export default EmptyModel;
